import { render } from "./AntUpload.vue?vue&type=template&id=58cb93e5"
import script from "./AntUpload.vue?vue&type=script&lang=js"
export * from "./AntUpload.vue?vue&type=script&lang=js"

import "./AntUpload.vue?vue&type=style&index=0&id=58cb93e5&lang=css"

import exportComponent from "C:\\Users\\luke\\Desktop\\membership_application\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__